import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, Routes } from '@angular/router';
import { RouteResolver } from '@df/catalog/route/route.resolver';
import { inject } from '@angular/core';
import { VipService } from '../module/vip/vip.service';
import { Product } from '@df/catalog/product/product';
export const catalogRoutes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import(
                /* webpackChunkName: "catalog-view.async" */
                './ui/catalog-view.component'
            ).then(m => m.CatalogViewComponent),
        resolve: {
            route: async (activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) => {
                const routeResolver = inject(RouteResolver);
                const vipService = inject(VipService);
                const router = inject(Router);
                const route = await routeResolver.resolve(activatedRouteSnapshot, routerStateSnapshot);
                const target = route.target;
                if (target?.type === Product.type) {
                    if (await vipService.isRestrictionApplied(target as Product)) {
                        router.navigateByUrl('/', { replaceUrl: true });
                        return null;
                    }
                }
                return route;
            }
        },
        data: {
            preload: true
        }
    }
];
